import {MI} from "../init";
import {getRandomInt} from "../../framework/src/helpers";
import {madnes_key_exist} from "../../framework/src/engine/madnes/madnes_object";

/**
 * @abstract @constructor
 * @param {MadnesObject} sprite
 * @param {number} symbolNum
 * @param {number} reelX
 * @param {number} reelY
 * @returns {AbstractSymbol}
 */
export default function AbstractSymbol(sprite, symbolNum, reelX, reelY) {

    /**
     * @type {MadnesObject}
     */
    this.parentSprite = sprite;

    /**
     * @type {string}
     */
    this.spriteName = sprite.name;

    /**
     * @protected
     * @type {number}
     */
    this._symbolNum;
    this.setSymbolNum(symbolNum);

    /**
     * @type {string}
     */
    this.symbolName = this.getSymbolName();

    this.reelPos = { 'x': reelX, 'y': reelY };

    /**
     * @type {boolean}
     */
    this.temporary = false;

    /**
     * @type {boolean}
     */
    this.spreaded = false;

    /** @type {MadnesObject|null} */
    this.shineSymbol;
    /** @type {MadnesTween} */
    this.shineAnim;

    this._blurred = false;
};

/** @abstract */
AbstractSymbol.prototype.clear = function() {};

/**
 * @abstract
 * @return {AbstractSymbol}
 */
AbstractSymbol.prototype.createSymbol = function() {};

/**
 * @abstract
 * @return {AbstractSymbol}
 */
AbstractSymbol.prototype.createSimpleSymbol = function() {};

/**
 * @abstract
 * @returns {AbstractSymbol}
 */
AbstractSymbol.prototype.createWinSymbol = function() {};

/** @abstract */
AbstractSymbol.prototype.createStandAnim = function() {};
/** @abstract */
AbstractSymbol.prototype.playStandAnim = function() {};
/** @abstract */
AbstractSymbol.prototype.stopStandAnim = function() {};

/** @abstract */
AbstractSymbol.prototype.fadeOutStandAnim = function() {};
AbstractSymbol.prototype.fadeInStandAnim = function() {};

/**
 * @abstract
 * @returns {number}
 */
AbstractSymbol.prototype.getShineColor = function() {};

/**
 * @abstract
 * @returns {Promise}
 */
AbstractSymbol.prototype.playWinAnim = function() {};

AbstractSymbol.prototype._clearParentSprite = function() {
    if(this.parentSprite.getTextureName() !== "symbols_atlas") {
        this.parentSprite.setTexture("symbols_atlas");
    }
};

/**
 * @returns {AbstractSymbol}
 */
AbstractSymbol.prototype.createBlurSymbol = function() {
    this.clear();
    this.parentSprite.setTexture("symbols_blur_atlas").setFrameName(this.symbolName + "_blur");
    this.parentSprite.setAnchor(0.5, 0.5);

    this._blurred = true;

    return this;
};

AbstractSymbol.prototype.createShineAnim = function() {

    // if(!this.shineSymbol) {
    //     return;
    // }
    //
    // this.shineSymbol.setAlpha(0.7);
    //
    // this.shineAnim = MI.addTween().to(this.shineSymbol, { 'alpha': 1 }, {
    //     'duration': getRandomInt(1000, 2000),
    //     'yoyo': true,
    //     'count': -1
    // });
};

AbstractSymbol.prototype.stopShineAnim = function() {

    if(!this.shineAnim) {
        return;
    }

    this.shineAnim.pause();
};

AbstractSymbol.prototype.playShineAnim = function() {

    if(!this.shineAnim || !this.parentSprite) {
        return;
    }

    this.shineAnim = MI.addTween().to(this.shineSymbol, { 'alpha': 1 }, {
        'duration': getRandomInt(1000, 2000),
        'yoyo': true,
        'callback': () => this.playShineAnim()
    });

    // this.shineAnim.start();
};

AbstractSymbol.prototype.destroyShineAnim = function() {

    if(!this.shineAnim) {
        return;
    }

    this.shineAnim.stop();
    this.shineAnim.destroy();
    this.shineAnim = null;
};

/*AbstractSymbol.prototype.fadeOutShineAnim = function() {
	var _self = this;

	if(!this.shineAnim) {
		return;
	}

	this.shineAnim.stop();
	this.shineAnim = MI.addTween().to(this.shineSymbol, { 'alpha': 0 }, {
		'duration': 100,
		'callback': function() {
			_self.destroyShineAnim();
		}
	});
};*/

AbstractSymbol.prototype.setName = function(name) {
    this.getSprite().setName(name);
    this.spriteName = name;
};

/**
 * @public
 * @returns {number}
 */
AbstractSymbol.prototype.getReelX = function() {
    return this.reelPos['x'];
};

/**
 * @returns {number}
 */
AbstractSymbol.prototype.getReelY = function() {
    return this.reelPos['y'];
};

AbstractSymbol.prototype.setReelX = function(x) {
    this.reelPos['x'] = x;
};

AbstractSymbol.prototype.setReelY = function(y) {
    this.reelPos['y'] = y;
};

/**
 * @param {number} num
 * @param {boolean=} keepVisibility
 */
AbstractSymbol.prototype.setPosX = function(num, keepVisibility) {
    this.parentSprite.setPosX(num, keepVisibility);
};

/**
 * @param {number} num
 * @param {boolean=} keepVisibility
 */
AbstractSymbol.prototype.setPosY = function(num, keepVisibility) {
    this.parentSprite.setPosY(num, keepVisibility);
};

AbstractSymbol.prototype.getPosX = function() {
    return this.parentSprite.getPosX();
};

AbstractSymbol.prototype.getPosY = function() {
    return this.parentSprite.getPosY();
};

AbstractSymbol.prototype.setVisible = function(bool) {
    if (this.parentSprite)
        this.parentSprite.setVisible(bool);
    return this;
};

AbstractSymbol.prototype.getVisible = function() {
    return this.parentSprite.getVisible();
};

/**
 * @param {number} num
 * @returns {AbstractSymbol}
 */
AbstractSymbol.prototype.setAlpha = function(num) {
    this.parentSprite.setAlpha(num);
    return this;
};

AbstractSymbol.prototype.getAlpha = function() {
    return this.parentSprite.getAlpha();
};

/**
 * @param {number} x
 * @param {number} y
 * @returns {AbstractSymbol}
 */
AbstractSymbol.prototype.setScale = function(x, y) {
    this.parentSprite.setScale(x, y);
    return this;
};

/**
 * @param {number} num
 * @returns {undefined}
 */
AbstractSymbol.prototype.setSymbolNum = function(num) {
    if(typeof num === "undefined") {
        console.log(this);
        throw new Error("symbol num error");
    }

    this._symbolNum = num;
};

/**
 * @returns {number}
 */
AbstractSymbol.prototype.getSymbolNum = function() {
    return this._symbolNum;
};

/**
 * @param {number} x
 * @param {number} y
 * @param {string|null} symbolName
 * @param {string=} spriteName
 * @returns {MadnesObject}
 */
AbstractSymbol.prototype.createImage = function(x, y, symbolName, spriteName) {
    var child = MI.addImg(x, y, symbolName, spriteName).setAnchor(0.5, 0.5);
    this.parentSprite.addChild(child);

    return child;
};

AbstractSymbol.prototype.getSymbolName = function() {
    return AbstractSymbol.getSymbolByNum(this.getSymbolNum());
};

/**
 * @param {number} reelX
 * @param {number} reelY
 * @returns {AbstractSymbol}
 */
AbstractSymbol.prototype.setReelPos = function(reelX, reelY) {
    this.reelPos = { 'x': reelX, 'y': reelY };
    return this;
};

AbstractSymbol.prototype.removeChilds = function() {
    this.parentSprite.removeChilds();
};

AbstractSymbol.prototype.kill = function() {
    this.parentSprite && this.parentSprite.kill();
};

AbstractSymbol.prototype.revive = function() {
    this.parentSprite && this.parentSprite.revive();
};

AbstractSymbol.prototype.destroy = function() {

    if(this.parentSprite) {
        this.clear();
        this.parentSprite.destroy();
    }
    this.parentSprite = null;
};

AbstractSymbol.prototype.isDestroyed = function() {
    return !this.parentSprite;
};

/**
 * @public
 * @returns {MadnesObject}
 */
AbstractSymbol.prototype.getSprite = function() {
    return this.parentSprite;
};

/**
 * @returns {string}
 */
AbstractSymbol.prototype._name = function() {
    return this.spriteName + "_" + this.symbolName;
};

/**
 * @param {number} num
 * @returns {string}
 */
AbstractSymbol.getSymbolByNum = function(num) {
    var symbol = MI.getPictureConvert()[num];

    if(symbol === "symbol_9") {
        symbol = "symbol_Candle";
    }

    if(symbol === "symbol_10") {
        symbol = "symbol_Pestle";
    }

    return symbol;
};

/**
 * @param {string} symbol
 * @returns {number}
 */
AbstractSymbol.getNumBySymbolName = function(symbol) {

    if(symbol === "symbol_9") {
        symbol = "symbol_Candle";
    }

    if(symbol === "symbol_10") {
        symbol = "symbol_Pestle";
    }

    return MI.getPictureConvert().indexOf(symbol);
};

/**
 * @param {number} posY
 * @returns {string}
 */
AbstractSymbol.getSpreadDirection = function(posY) {
    switch(posY * 1) {
        case 0:
            return "top";
        case 2:
            return "bottom";
        case 3:
        default:
            return "center";
    }
};

/**
 * @returns {Array|Object}
 */
AbstractSymbol.getRealPosition = function(pos) {

    if(Array.isArray(pos)) {

        return [pos[0] - 228/2, (206/2 - pos[1]) * -1];

    } else {

        return {
            'x': pos['x'] - 228/2,
            'y': (206/2 - pos['y']) * -1,
            'c': pos['c']
        }
    }
};

AbstractSymbol.spriteExists = function(sprite) {
    return !(!sprite || !sprite.name || !madnes_key_exist(sprite.name));
};